export const CLAIM_SERVICE_TYPE = {
  INPATIENT: 'inpatient',
  OUTPATIENT: 'outpatient',
  INPATIENT_FINAL: 'final',
};

export const REFERENCE_SERVICE_TYPE = {
  MIMS: 'MIMS',
  KFA: 'KFA',
  BPOM: 'BPOM',
};

export const ADMISSION_TYPE = {
  OUTPATIENT: 'OUTPATIENT',
  INPATIENT: 'INPATIENT',
};

export const ADMISSION_METHOD = {
  REIMBURSEMENT: 'REIMBURSEMENT',
  CASHLESS: 'CASHLESS',
};

export const CLAIM_MODE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
};
export const SUBMIT_MUTATION_LIFECYCLE = {
  pending: 'loading',
  success: 'success',
  error: 'error',
};
